// set up header, contains a uncontrolled form

import React, { Component } from 'react'
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Jumbotron, Modal, Label,
	ModalHeader, ModalBody, Button, Input, Form, FormGroup  } from 'reactstrap'
import { NavLink } from 'react-router-dom'

class Header extends Component {
	
	constructor (props) {
		super(props)
		this.state = {
			isNavOpen: false,
            isModalOpen: false
		}
		// set up header, contains a uncontrolled form
		this.toggleModal = this.toggleModal.bind(this)
		this.handleLogin = this.handleLogin.bind(this)
	}

	toggleModal () {
		this.setState({
			isModalOpen: !this.state.isModalOpen
		})
	}

	toggleNav () {
		this.setState({
			isOpen: !this.state.isOpen,
			isModalOpen: false
		})
	}

    handleLogin(event) {
        this.toggleModal();
        alert("Username: " + this.username.value + " Password: " + this.password.value
            + " Remember: " + this.remember.checked);
        event.preventDefault();

    }


	render() {
		return (
			<React.Fragment> 
				<Navbar dark expand = 'md'>
          			<div className = 'container'>
          				<NavbarToggler onClick= {this.toggleNav.bind(this)} />
            			<NavbarBrand className = 'mr-auto' href='/'>
            				{/* <img src = 'assets/images/logo.png' height = '30' with = '41'/> */}
            			</NavbarBrand>
            			<Collapse isOpen={this.state.isOpen} navbar>
	            			<Nav navbar>
	            				<NavItem>
	            					<NavLink className='nav-link' to='/home'>
	            						<span className = 'fa fa-home fa-lg'></span> Home
	            					</NavLink>
	            				</NavItem>
	            			    <NavItem>
	            					<NavLink className='nav-link' to='/menu'>
	            						<span className = 'fa fa-list fa-lg'></span> Menu
	            					</NavLink>
	            				</NavItem>
	            				<NavItem>
	            					<NavLink className='nav-link' to='/aboutus'>
	            						<span className = 'fa fa-info fa-lg'></span> About Us
	            					</NavLink>
	            				</NavItem>
	            				<NavItem>
	            					<NavLink className='nav-link' to='/contactus'>
	            						<span className = 'fa fa-address-card fa-lg'></span> Contact Us
	            					</NavLink>
	            				</NavItem>
							</Nav>
							<Nav className = 'ml-auto' navbar>
	            				<NavItem>
	            					<Button outline onClick = {this.toggleModal}>
	            						<span className = 'fa fa-sign-in fa-lg'></span> Login
	            					</Button>
	            				</NavItem>
	            			</Nav>
	            		</Collapse>
          			</div>
        		</Navbar>

        		<Jumbotron>
        			<div className = 'container'> 
        				<div className = 'row row-header'>
        					<div className = 'col-12 col-sm-6'>
        						<h1>Fatima Bakery</h1>
                       <p>We take inspiration from the World's best cakes and sweets, and create a unique taste experience. Our lipsmacking creations will tickle your testing senses!</p>
        					</div>
        				</div>
        			</div>
        		</Jumbotron>

				<Modal isOpen = {this.state.isModalOpen} toggle = {this.toggleModal} > 
        			<ModalHeader toggle = {this.toggleModal}>Login</ModalHeader>
        			<ModalBody>
        				<Form onSubmit = {this.handleLogin}>
        					<FormGroup>
        						<Label htmlFor = 'username'>Username</Label>
        						<Input type = 'text' id = 'username' name = 'username' 
        							   innerRef = {(input) => this.username = input}
        						/>  						
        					</FormGroup>
        					<FormGroup>
        						<Label htmlFor = 'password'>Password</Label>
        						<Input type = 'password' id = 'password' name = 'password' />  						
        					</FormGroup>
        					<FormGroup check>
        						<Label check>
        							<Input type='checkbox' name= 'remember' />
        							Remember me
        						</Label>					
        					</FormGroup>
        					<Button className = 'float-right' value ='submit' color = 'primary'
        					>Login</Button>
        				</Form>
        			</ModalBody>
        		</Modal>
			</React.Fragment>
		)
	}
}


export default Header